export default __webpack_public_path__ + "static/media/background.5a80c6ad.png";